var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_404"},[_c('p',{staticClass:"page-container"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("点击返回首页 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }